import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const nav = [
  { path: '/', icon: '📊', label: 'Dashboard' },
  { path: '/assistant', icon: '🤖', label: 'AI Assistant' },
  { path: '/income', icon: '💰', label: 'Income' },
  { path: '/commissions', icon: '💼', label: 'Commissions' },
  { path: '/expenses', icon: '💸', label: 'Expenses' },
  { path: '/recurring-bills', icon: '🔄', label: 'Recurring Bills' },
  { path: '/notes', icon: '📝', label: 'Notes' },
  { path: '/investments', icon: '📈', label: 'Investments' },
  { path: '/properties', icon: '🏢', label: 'Real Estate' },
  { path: '/agent', icon: '🏠', label: 'Agent' },
  { path: '/analysis', icon: '📈', label: 'Market Analysis' },
  { path: '/project-analysis', icon: '🏗️', label: 'Project Analysis' },
];

const investmentsSub = [
  { path: '/investments', icon: '📊', label: 'Overview' },
  { path: '/investments/stocks', icon: '📈', label: 'Stocks' },
  { path: '/investments/crypto', icon: '🪙', label: 'Crypto' },
  { path: '/investments/other', icon: '🏦', label: 'Other' },
];

function NavLinks({ onNavigate }) {
  const location = useLocation();
  const inInvestments = location.pathname.startsWith('/investments');

  return (
    <>
      {nav.map(item => {
        // The Investments parent is highlighted whenever we're anywhere in the section
        const active = item.path === '/investments'
          ? inInvestments
          : location.pathname === item.path;
        return (
          <div key={item.path}>
            <Link to={item.path} onClick={onNavigate}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all ${
                active ? 'bg-green-600 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              }`}>
              <span>{item.icon}</span>{item.label}
            </Link>
            {item.path === '/investments' && inInvestments && (
              <div className="ml-4 mt-1 space-y-1 border-l border-gray-700 pl-2">
                {investmentsSub.map(sub => (
                  <Link key={sub.path} to={sub.path} onClick={onNavigate}
                    className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs transition-all ${
                      location.pathname === sub.path ? 'bg-green-700 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                    }`}>
                    <span>{sub.icon}</span>{sub.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}

export default function Sidebar({ onLogout, user }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Mobile top bar */}
      <div className="md:hidden flex items-center justify-between bg-gray-900 text-white px-4 py-3 fixed top-0 left-0 right-0 z-50">
        <button onClick={() => setOpen(!open)} className="text-white text-2xl">
          {open ? '✕' : '☰'}
        </button>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center text-sm">💰</div>
          <span className="font-bold text-sm">AffinityFinance</span>
        </div>
      </div>

      {/* Mobile menu overlay */}
      {open && (
        <div className="md:hidden fixed inset-0 z-40 bg-black bg-opacity-50" onClick={() => setOpen(false)}>
          <div className="w-64 min-h-screen bg-gray-900 text-white flex flex-col" onClick={e => e.stopPropagation()}>
            <div className="p-6 border-b border-gray-700 pt-16">
              <p className="text-sm text-gray-400">👋 {user?.name}</p>
            </div>
            <nav className="flex-1 p-4 space-y-1">
              <NavLinks onNavigate={() => setOpen(false)} />
            </nav>
            <div className="p-4 border-t border-gray-700">
              <button onClick={onLogout} className="w-full text-left text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-gray-800">
                🚪 Sign out
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Desktop sidebar */}
      <div className="hidden md:flex w-56 min-h-screen bg-gray-900 text-white flex-col">
        <div className="p-6 border-b border-gray-700">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-green-500 rounded-xl flex items-center justify-center text-lg">💰</div>
            <div>
              <p className="font-bold text-sm">AffinityFinance</p>
              <p className="text-xs text-gray-400">Dubai</p>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          <NavLinks />
        </nav>
        <div className="p-4 border-t border-gray-700">
          {user && <p className="text-xs text-gray-400 mb-3">👋 {user.name}</p>}
          <button onClick={onLogout} className="w-full text-left text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-gray-800 transition">
            🚪 Sign out
          </button>
        </div>
      </div>
    </>
  );
}
